import { Modal } from 'Components';
import { useTranslation } from 'react-i18next';
import styles from './CreateExitModal.module.scss';
import Button from '../Button';

interface ModalProps {
	visible: boolean;
	onCancel: () => void;
	onExit: () => void;
}

const CreateExitModal: React.FC<ModalProps> = ({
	visible,
	onExit,
	onCancel
}) => {
	const { t } = useTranslation();

	return (
		<Modal
			visible={visible}
			centered
			onCancel={onCancel}
			footer={null}
			size="xs"
		>
			<div className={styles.header}>
				{t('learning.createAssignment.exitModal.title')}
			</div>

			<div className={styles.description}>
				{t('learning.createAssignment.exitModal.description')}
			</div>

			<div className={styles.btnContainer}>
				<Button variant="borderless" size="small" onClick={onCancel}>
					{t('learning.createAssignment.exitModal.continueCreation')}
				</Button>

				<Button onClick={onExit} size="small">
					{t('learning.createAssignment.exitModal.exitAndDiscard')}
				</Button>
			</div>
		</Modal>
	);
};

export default CreateExitModal;